import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c(VCard,{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"outlined":"","width":"100%","height":"100%","elevation":"5"}},[_c('Toolbar',{attrs:{"title":'Gruppe ' + _vm.group.o,"back":""}}),_c(VDivider),_c(VCardText,{staticStyle:{"height":"100%","overflow":"hidden"}},[(_vm.loaded)?_c('GroupForm',{attrs:{"action":"openGroup","group":_vm.group,"showSubgroups":false,"showParentgroups":false,"showMembers":true}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }